import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
    Card,
    CardBody,
    Button,
    TabContent,
    TabPane,
    NavItem,
    CardHeader,
    Nav,
    Row,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    NavLink
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
    AxiosAPI,
    getGroupID,
    getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
    gAPI_UserUploads,
    gAPI_BmbUploads,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
// import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import UploadIconsButton from './components/UploadIconsButton';
import UploadExternalIconsButton from './components/UploadExternalIconsButton';
import SelectedIcon from './components/SelectedIcon';
import UserUploadSelectedIcon from './components/UserUploadSelectedIcon';
import Pagination from '../../../../../containers/pages/Pagination';
function Index({
    propertyId,
    selectedSvg,
    togglegallery,
    hideUserUploads,
    searchText, }) {
    if (hideUserUploads === undefined) {
        hideUserUploads = false;
    }
    if (searchText === undefined) {
        searchText = '';
    }
    const [activeTab, setActiveTab] = useState('standard');
    const [loading, setLoading] = useState(true);
    const [bmbloading, setbmbLoading] = useState(true);
    const [photos, setphotos] = useState([]);
    const [bmbphotos, setbmbphotos] = useState([]);
    const [chosenImage, setchosenImage] = useState('');
    const [bmbsearch, setBmbSearch] = useState(searchText);
    const [myUploadSearch, setmyUploadSearch] = useState('');
    const [bmbpageSizes, setbmbpageSizes] = useState([10, 15, 20, 25, 30]);
    const [bmbcurrentPage, setbmbcurrentPage] = useState(1);
    const [bmbSelectedPageSize, setbmbSelectedPageSize] = useState(30);
    const [bmbTotalItems, setbmbTotalItems] = useState(0);
    const [bmbTotalPages, setbmbTotalPages] = useState(1);
    const [bmbUploadButton, setBmbUploadButton] = useState(false);
    const [userpageSizes, setuserpageSizes] = useState([10, 15, 20, 25, 30]);
    const [usercurrentPage, setusercurrentPage] = useState(1);
    const [userSelectedPageSize, setuserSelectedPageSize] = useState(30);
    const [userTotalItems, setuserTotalItems] = useState(0);
    const [userTotalPages, setuserTotalPages] = useState(1);
    const toggleAppMenu = (tab) => {
        setActiveTab(tab);
    };
    useEffect(() => {
        LoadData();
    }, [propertyId, myUploadSearch, usercurrentPage, userSelectedPageSize]);

    useEffect(() => {
        ShowUploadButton();
        LoadBmbData();
    }, [propertyId, bmbsearch, bmbcurrentPage, bmbSelectedPageSize]);

    const ShowUploadButton = () => {
        const userId = getUserID();
        if (
            userId == '0b264b20-dc1a-40e9-87d2-8877b5a0e089' ||
            userId == '6fc9447c-ddc3-4b0c-9af5-464471e5cd55' ||
            userId == 'a98e69d8-9c90-48cd-ae61-de4628be2b15'
        ) {
            setBmbUploadButton(true);
        }
    };
    const [selectAll, setSelectAll] = useState(false);

    const onSearchKey = (e) => {
        //if (e.key === "Enter") {
        setbmbcurrentPage(1);
        setBmbSearch(e.target.value.toLowerCase());
        LoadBmbData();
        //}
    };
    const onSearchKeyUserUploads = (e) => {
        //if (e.key === "Enter") {
        setusercurrentPage(1);
        setmyUploadSearch(e.target.value.toLowerCase());
        LoadData();
        //}
    };

    const changeBmbPageSize = (size) => {
        setbmbSelectedPageSize(size);
        setbmbcurrentPage(1);
    };

    const onChangeBmbPage = (page) => {
        setbmbcurrentPage(page);
    };

    const changeUserPageSize = (size) => {
        setuserSelectedPageSize(size);
        setusercurrentPage(1);
    };

    const onChangeUserPage = (page) => {
        setusercurrentPage(page);
    };


    const ParentImage = (id) => {
        setchosenImage(id);
        let objIndex = bmbphotos.findIndex((obj) => obj.id == id);
        bmbphotos[objIndex].selected = true;
        setbmbphotos(bmbphotos);
    };

    const ParentDeleteImage = (id) => {
        const values = [...bmbphotos];
        let objIndex = bmbphotos.findIndex((obj) => obj.id == id);
        values.splice(objIndex, 1);
        setbmbphotos(values);
    };

    const ParentEditImage = (id, tags) => {
        let objIndex = bmbphotos.findIndex((obj) => obj.id == id);
        bmbphotos[objIndex].tags = true;
        setbmbphotos(bmbphotos);
    };

    const ParentUserDeleteImage = (id) => {
        const values = [...photos];
        let objIndex = photos.findIndex((obj) => obj.id == id);
        values.splice(objIndex, 1);
        setphotos(values);
    };

    const ParentUserEditImage = (id, tags) => {
        let objIndex = photos.findIndex((obj) => obj.id == id);
        photos[objIndex].tags = true;
        setphotos(photos);
    };

    const ParentUserUploadImage = (id) => {
        setchosenImage(id);
        let objIndex = photos.findIndex((obj) => obj.id == id);
        photos[objIndex].selected = true;
        setphotos(photos);
    };

    const AddImage = () => {
        let objIndex = bmbphotos.findIndex((obj) => obj.id == chosenImage);
        selectedSvg(bmbphotos[objIndex]);
        togglegallery();
    };

    const AddUserImage = () => {
        let objIndex = photos.findIndex((obj) => obj.id == chosenImage);
        selectedSvg(photos[objIndex]);
        togglegallery();
    };

    const LoadData = () => {
        if (hideUserUploads != true) {
            let searchkeyword = myUploadSearch;
            if (bmbsearch === 'avatar') {
                searchkeyword = '';
            }
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_UserUploads}?groupId=${getGroupID()}&tags=${searchkeyword}&pageNumber=${usercurrentPage}&pageSize=${userSelectedPageSize}&propertyId=${propertyId}&format=SvgGallery&caption=&path=`,
            })
                .then((res) => {
                    setphotos(res.data.images);
                    setuserTotalItems(res.data.totalItems);
                    setuserTotalPages(res.data.totalPages);
                    setLoading(false);
                })
                .catch((err) => console.log('err', err));
        }
    };

    const LoadBmbData = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_BmbUploads}?tags=${bmbsearch}&pageNumber=${bmbcurrentPage}&pageSize=${bmbSelectedPageSize}&type=Bmb&format=SvgGallery&caption=`,
        })
            .then((res) => {
                setbmbphotos(res.data.images);
                setbmbTotalItems(res.data.totalItems);
                setbmbTotalPages(res.data.totalPages);
                setbmbLoading(false);
            })
            .catch((err) => console.log('err', err));
    };
    const startBmbIndex = (bmbcurrentPage - 1) * bmbSelectedPageSize;
    const endBmbIndex = bmbcurrentPage * bmbSelectedPageSize;
    const startUserIndex = (usercurrentPage - 1) * userSelectedPageSize;
    const endUserIndex = usercurrentPage * userSelectedPageSize;
    console.log(photos);
    return (
        <Fragment>
            <CardHeader className="pl-0 pr-0 mb-2">
                <Nav tabs className="card-header-tabs separator-tabs ml-0 mr-0">
                    <NavItem className="w-auto text-center">
                        <NavLink
                            className={classnames({
                                active: activeTab === 'standard',
                                'nav-link': true,
                            })}
                            onClick={() => {
                                toggleAppMenu('standard');
                            }}
                            to="#"
                        >
                            <span

                                style={{ color: `${activeTab === 'standard' ? 'var(--theme-color-1)' : '#8f8f8f'}`, fontWeight: 600, }}
                            >
                                Icon Stock Library
                            </span>

                        </NavLink>
                    </NavItem>
                    {hideUserUploads != true ? (
                        <NavItem className="w-auto text-center">
                            <NavLink
                                className={classnames({
                                    active: activeTab === 'embed',
                                    'nav-link': true,
                                })}
                                onClick={() => {
                                    toggleAppMenu('embed');
                                }}
                                to="#"
                            >
                                <span

                                    style={{ color: `${activeTab === 'embed' ? 'var(--theme-color-1)' : '#8f8f8f'}`, fontWeight: 600, }}
                                >
                                    My Icon Uploads
                                </span>

                            </NavLink>
                        </NavItem>
                    ) : null}
                </Nav>
            </CardHeader>

            <TabContent activeTab={activeTab} className="">
                <TabPane tabId="standard" className="chat-app-tab-pane">
                    <Row>
                        <Colxx xxs="3">
                            <div
                                className="search-sm d-inline-block float-md-left mr-1  align-top mt-2 mb-2"
                                style={{ width: '100%' }}
                            >
                                <input
                                    type="text"
                                    name="keyword"
                                    id="search"
                                    placeholder="Search for hair, nail, Christmas and more"
                                    onKeyUp={(e) => onSearchKey(e)}
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </Colxx>

                        <Colxx xxs="6">
                            <div className='d-flex mt-2'>
                                {bmbUploadButton && (
                                    <UploadIconsButton
                                        propertyId={propertyId}
                                        bmb={true}
                                        parentBmbData={LoadBmbData}
                                    />
                                )}

                                {togglegallery && (
                                    <div className="ml-2">
                                        <Button
                                            color="secondary btn-sec"
                                            className=""
                                            size="xs"
                                            onClick={AddImage}
                                        >
                                            Add to my Chatbot
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </Colxx>

                    </Row>
                    <Card className="mb-4 mt-2">
                        <CardBody>
                            <Row>


                                <Colxx xxs="9"></Colxx>
                                <Colxx xxs="3">
                                    <div className="float-md-right">
                                        <span className="text-muted text-small mr-1">{`${startBmbIndex}-${endBmbIndex} of ${bmbTotalItems} `}</span>
                                        <UncontrolledDropdown className="d-inline-block">
                                            <DropdownToggle caret color="outline-dark" size="xs">
                                                {bmbSelectedPageSize}
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                {bmbpageSizes.map((size, index) => {
                                                    return (
                                                        <DropdownItem
                                                            key={index}
                                                            onClick={() => changeBmbPageSize(size)}
                                                        >
                                                            {size}
                                                        </DropdownItem>
                                                    );
                                                })}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </Colxx>
                            </Row>
                            {!bmbloading && (
                                <Row>
                                    <Colxx xxs="12">
                                        <div className='row'>
                                            {bmbphotos && bmbphotos.map((img, index) => (
                                                <div className='col-sm-2 col-md-2'>
                                                    <SelectedIcon
                                                        selected={selectAll ? true : false}
                                                        key={index}
                                                        margin={'2px'}
                                                        index={index}
                                                        photo={img}
                                                        left={'1px'}
                                                        top={'1px'}
                                                        ParentImage={ParentImage}
                                                        chosenImage={chosenImage}
                                                        ParentDeleteImage={ParentDeleteImage}
                                                        ParentEditImage={ParentEditImage}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </Colxx>
                                </Row>
                            )}
                            <Row>
                                <Pagination
                                    currentPage={bmbcurrentPage}
                                    totalPage={bmbTotalPages}
                                    onChangePage={(i) => onChangeBmbPage(i)}
                                />
                            </Row>

                        </CardBody>
                    </Card>
                </TabPane>
                {hideUserUploads != true ? (
                    <TabPane tabId="embed" className="chat-app-tab-pane">
                        <Row>
                            <Colxx xxs="3">
                                <div
                                    className="search-sm d-inline-block float-md-left mr-1  align-top mt-2 mb-4"
                                    style={{ width: '100%' }}
                                >
                                    <input
                                        type="text"
                                        name="keyword"
                                        id="search"
                                        placeholder="Search for hair, nail, Christmas and more"
                                        onKeyUp={(e) => onSearchKeyUserUploads(e)}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Colxx>

                            <Colxx xxs="8">
                                <div className='d-flex mt-2'>
                                    <div>
                                        {propertyId !== '-1' && (
                                            <UploadIconsButton
                                                propertyId={propertyId}
                                                bmb={false}
                                                parentLoadData={LoadData}
                                            />
                                        )}
                                    </div>
                                    <div className='ml-1' >
                                        {propertyId !== '-1' && (
                                            <UploadExternalIconsButton
                                                propertyId={propertyId}
                                                parentLoadData={LoadData}
                                            />
                                        )}
                                    </div>
                                    {togglegallery && (
                                        <div className=" ml-2">
                                            <Button
                                                color="secondary "
                                                className="btn-sec"
                                                size="xs"
                                                onClick={AddUserImage}
                                            >
                                                Add to my Chatbot
                                            </Button>
                                        </div>
                                    )}
                                </div>


                            </Colxx>

                        </Row>
                        <Card className="mb-4">
                            <CardBody>
                                <Row className='mb-2'>
                                    <Colxx xxs="9"></Colxx>

                                    <Colxx xxs="3">
                                        <div className="float-md-right">
                                            <span className="text-muted text-small mr-1">{`${startUserIndex}-${endUserIndex} of ${userTotalItems} `}</span>
                                            <UncontrolledDropdown className="d-inline-block">
                                                <DropdownToggle caret color="outline-dark" size="xs">
                                                    {userSelectedPageSize}
                                                </DropdownToggle>
                                                <DropdownMenu right>
                                                    {userpageSizes.map((size, index) => {
                                                        return (
                                                            <DropdownItem
                                                                key={index}
                                                                onClick={() => changeUserPageSize(size)}
                                                            >
                                                                {size}
                                                            </DropdownItem>
                                                        );
                                                    })}
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </div>
                                    </Colxx>
                                </Row>
                                {!loading && (
                                    <Row>
                                        <Colxx xxs="12">
                                            <div className='row'>
                                                {photos && photos.map((img, index) => (
                                                    <div className='col-sm-2 col-md-2'>
                                                        <UserUploadSelectedIcon
                                                            selected={selectAll ? true : false}
                                                            key={index}
                                                            index={index}
                                                            photo={img}
                                                            ParentUserUploadImage={ParentUserUploadImage}
                                                            chosenImage={chosenImage}
                                                            ParentUserDeleteImage={ParentUserDeleteImage}
                                                            ParentUserEditImage={ParentUserEditImage}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </Colxx>
                                    </Row>
                                )}
                                <Row>
                                    <Pagination
                                        currentPage={usercurrentPage}
                                        totalPage={userTotalPages}
                                        onChangePage={(i) => onChangeUserPage(i)}
                                    />
                                </Row>

                            </CardBody>
                        </Card>
                    </TabPane>
                ) : null}
            </TabContent>
        </Fragment >
    );

}
const mapStateToProps = ({ settings }) => {
    const { propertyId, email } = settings;
    return {
        propertyId,
        email,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));